import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import CodeForm from '../components/CodeForm/CodeForm'
import { Container } from 'react-bootstrap'

function Code() {
  return (
    <div>
        <Navbar/>
<Container>
            <CodeForm/>

</Container>
        <Footer/>
    </div>
  )
}

export default Code